import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, token } from "@/lib/api";

export const RequireAdmin = ({ children }) => {
  const [ok, setOk] = useState(token() ? null : false);

  useEffect(() => {
    if (!token()) return;
    api.me().then(() => setOk(true)).catch(() => setOk(false));
  }, []);

  if (ok === null) return <div className="min-h-screen bg-[#121417]" data-testid="admin-auth-checking" />;
  if (!ok) return <Navigate to="/admin/login" replace />;
  return children;
};
